export default "__VITE_ASSET__8161424b__"